import { createWithEqualityFn } from "zustand/traditional";
import { modules } from "../../constants";
import { initialTableSettings } from "../agentMovement";
import { actions } from "./actions";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export const initialState = {
    [modules.proficiencyMetrics.agentMovement]: initialTableSettings,
};

const tableSettingsStore = (set, get) => ({
    ...initialState,
    ...actions(set, get),
});

export const useTableSettingsStore = createWithEqualityFn(
    devtools(
        persist(
            tableSettingsStore,
            {
                name: 'table_settings_state',
                storage: createJSONStorage(() => localStorage)
            }
        )
    )
);
